import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import type { FontAwesomeIconProps } from '@hivebrite/design-system/FontAwesomeIcon';
import { SimpleCard } from '@hivebrite/design-system/SimpleCard';

import { openLoginModal } from 'hb-react/shared/utils/login/openLoginModal';

const DEFAULT_DESCRIPTION = s__(
  'LoginCard|Explore more content once connected.',
);
const DEFAULT_TITLE = ({
  componentName,
}: Pick<LoginCardProps, 'componentName'>) =>
  s__('LoginCard|Login to see %{componentName}').i__({
    componentName,
  });

interface LoginCardProps {
  componentName: string;
  description?: string;
  iconName?: FontAwesomeIconProps['iconName'];
  title?: string;
}
const LoginCard = ({
  componentName,
  description,
  iconName,
  title,
}: LoginCardProps) => (
  <Wrapper>
    <SimpleCard
      {...(iconName && {
        faIconProps: {
          iconName,
        },
      })}
      title={title || DEFAULT_TITLE({ componentName })}
      description={description || DEFAULT_DESCRIPTION}
      buttonProps={{
        children: s__('LoginCard|Login'),
        onClick: () => openLoginModal(),
      }}
    />
  </Wrapper>
);

export default LoginCard;

const Wrapper = styled(Box).attrs(() => ({
  display: 'block',
  my: 15,
  width: '100%',
}))``;
